import { Formik, Field, Form, ErrorMessage } from "formik";
import { Link } from "react-router-dom";
import { FORGOT_PASSWORD_VALIDATION } from "./Validations";

import { ReactComponent as LeftArrow } from "../../resources/icons/left_pointer.svg";

interface LoginValues {
  email: string;
}

const ForgotPasswordForm: React.FC = () => {
  const initialValues: LoginValues = {
    email: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={FORGOT_PASSWORD_VALIDATION}
      onSubmit={() => {}}
    >
      {({ isValid, touched, values, handleChange }) => (
        <Form>
          <div className="relative mb-8">
            <label htmlFor="email" className="block text-sm font-semibold mb-2">
              Email:
            </label>
            <Field
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              className="w-full p-3 border-2 rounded-lg"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleChange(e);
              }}
            />
            {touched.email && !isValid ? (
              <div className="text-red-500">
                <ErrorMessage name="email" />
              </div>
            ) : (
              ""
            )}
          </div>

          <button
            type="submit"
            disabled={!isValid || values.email === initialValues.email}
            className={`w-full py-3 bg-blue-500 text-white font-semibold rounded-lg ${
              !isValid || values.email === initialValues.email
                ? "bg-[#1672ec] bg-opacity-50"
                : "hover:bg-blue-600"
            }`}
          >
            Reset password
          </button>
          <div className="flex justify-center mt-6">
            <LeftArrow
              className="w-4 h-4 self-center mr-4"
              style={{ color: "rgb(37 99 235 / var(--tw-text-opacity, 1))" }}
            />
            <Link className="text-blue-600 nav-link" to={"/login"}>
              Back to login
            </Link>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ForgotPasswordForm;
